import { Controller } from 'stimulus';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
class _class extends Controller {
  connect() {
    this.hiddenClass = this.data.get('hiddenClass') || 'hidden';
  }

  toggle() {
    this.itemTargets.forEach(item => {
      item.classList.toggle(this.hiddenClass);
    });
  }

  show() {
    this.itemTargets.forEach(item => {
      item.classList.remove(this.hiddenClass);
    });
  }

  hide() {
    this.itemTargets.forEach(item => {
      item.classList.add(this.hiddenClass);
    });
  }

}

_defineProperty(_class, "targets", ['item']);

export default _class;
//# sourceMappingURL=index.js.map
